module.exports = __webpack_public_path__ + "img/20.f2d5d647.webp";